/**
 *   Created by ATopcu in 2019
 */
import scope from "./scope";
import SelectionState from "state/selections/SelectionState";
import { selectDefinitions } from "./selectors";
import { selectDefinitions as selectIssuerCountDefinitions } from "state/issuerCount/selectors";
import SummaryType from "state/selections/Constants/SummaryType";
import { selectBaseGroupingParams } from "state/selections/selector";
import { exchange } from "@ls/js-fetch";

export const SET_DEFINITION = `${scope}/SET_DEFINITION`;
export const setDefinition = (idx, definition) => ({
  type: SET_DEFINITION,
  idx,
  definition,
});

export const SET_DEFINITIONS = `${scope}/SET_DEFINITIONS`;
export const setDefinitions = (definitions) => ({
  type: SET_DEFINITIONS,
  definitions,
});

//Requests both issue count and issuer count data.
export const REQUEST_DATA = `${scope}/REQUEST_DATA`;
export const RECEIVE_DATA = `${scope}/RECEIVE_DATA`;
export const requestIssueCountData = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const issueCountDefinitions = selectDefinitions(SelectionState.COMMITTED)(
      state
    );
    const issuerCountDefinitions = selectIssuerCountDefinitions(
      SelectionState.COMMITTED
    )(state);

    if (
      issueCountDefinitions.length === 0 &&
      issuerCountDefinitions.length === 0
    ) {
      return;
    }

    const makeIssueCountRequest = async (summary) => {
      dispatch({ type: REQUEST_DATA, payload: { summary } });
      const state = getState();
      const [baseParams] = selectBaseGroupingParams(state);
      const params = {
        ...baseParams,
        summary,
        results: [],
      };
      if (issueCountDefinitions.some((def) => def.summary === summary)) {
        params.results.push("ISSUE_COUNT");
      }
      if (issuerCountDefinitions.some((def) => def.summary === summary)) {
        params.results.push("ISSUER_COUNT");
      }
      const url = process.env.REACT_APP_BASE_URL_GROUPING_SERVICE;

      dispatch({
        type: RECEIVE_DATA,
        payload: {
          summary,
          data: (
            await exchange({
              cancelId: `issue-count-data-${summary}`,
              url,
              params,
            })
          )?.data,
        },
      });
    };

    if (
      issueCountDefinitions.some(
        (def) => def.summary === SummaryType.ABSOLUTE
      ) ||
      issuerCountDefinitions.some((def) => def.summary === SummaryType.ABSOLUTE)
    ) {
      makeIssueCountRequest(SummaryType.ABSOLUTE).then();
    }
    if (
      issueCountDefinitions.some(
        (def) => def.summary === SummaryType.RELATIVE
      ) ||
      issuerCountDefinitions.some((def) => def.summary === SummaryType.RELATIVE)
    ) {
      makeIssueCountRequest(SummaryType.RELATIVE).then();
    }
  };
};
